// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"f341549f","377":"7e3bae85"}[chunkId] + ".chunk.js";
};